<atn-ds-page>
  <atn-ds-page-header
    pageHeader
    [name]="enumNameSg()"
    [breadcrumbs]="breadcrumbsSg()"
  />

  <div class="atn-enum">
    <div class="atn-enum__main">
      <atn-ds-widget title="Enum Summary">
        <div class="atn-enum__widget-content atn-enum__summary">
          <div>
            {{ enumDescriptionSg() }}
          </div>
          <div class="atn-enum__attributes">
            <div class="atn-enum__attribute">
              <div class="atn-enum__attribute-name">Name</div>
              <div class="atn-enum__attribute-value">
                {{ enumNameSg() }}
              </div>
            </div>
            <div class="atn-enum__attribute">
              <div class="atn-enum__attribute-name">ID</div>
              <div class="atn-enum__attribute-value">
                {{ enumIdSg() }}
              </div>
            </div>
            <div class="atn-enum__attribute">
              <div class="atn-enum__attribute-name">Entries Count</div>
              <div class="atn-enum__attribute-value">
                {{ entriesCountSg() }}
              </div>
            </div>
          </div>
        </div>
      </atn-ds-widget>
      <div class="atn-enum__entries-table-container">
        <atn-ds-table [config]="enumEntriesTableConfig" />
      </div>
    </div>
    <div class="atn-enum__side">
      <atn-ds-widget title="Notes">
        <div class="atn-enum__widget-content">Coming soon!</div>
      </atn-ds-widget>
    </div>
  </div>
</atn-ds-page>
